import {Injectable} from '@angular/core';
import {DataCoreService, DlistDto} from '@dabnet-kamu/libs/ui';
import {BehaviorSubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ControlConditionModel} from "../../../models/gen-control.model";

@Injectable()
export class TemDefterService {
  public period!: number;
  public receiptDate!: Date;
  public accountCode!: string;
  public corporateCode!: string;
  public conditionColName: any;
  public conditionColText: any;
  public controlCondition: ControlConditionModel[];
  public personCode!: number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {
  }


  setParams(period: number, receiptDate: Date, accountCode: string, corporateCode: string, personCode: number, controlCondition?: any, isReadOnly?:boolean, isBindCheck?:boolean) {
    this.period = period;
    this.receiptDate = receiptDate;
    this.accountCode = accountCode;
    this.corporateCode = corporateCode;
    this.personCode = personCode;
    this.controlCondition = controlCondition
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  getData(code: number,control:any, period: number,accountCode:any, baseEntity?: string, isSetData?: boolean, ) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select();
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select();
    if (period) filterArr.push(['Donem', '=', period]);
    if(accountCode) filterArr.push(['HesapKod', '=', accountCode]);
    //if (this.personCode) filterArr.push(['KisiKod', '=', this.personCode]);
    if (this.controlCondition) {
      this.controlCondition.forEach((item: any) => {
        filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);

      });
    }
    }
    if (code) filterArr.push(['DefterSiraNo', '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
